import { useState } from 'react';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './candidateEducation.css';
import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateColors } from '../../../../utils/colorUtilsClientInfo';
import UniversityIcon from '../../../../assets/images/ic_phd graduate.png';

const CandidateDegreeInfoPanel = ({ colorSeed, pgData, isEditing, onFieldChange }) => {
  const [viewDetails, setViewDetails] = useState(false);

  const colours = generateColors(colorSeed);

  const isSpecifyDegree = (degree = '') =>
    /specify/i.test(degree);

  return (
    <Container className='degreeInfoPanel'>
      <Row className="degreeInfoContainer mt-1 d-flex">
        <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center">
          <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
            <img src={UniversityIcon} alt="University Icon" />
          </span>
        </Col>
        <Col xs={8} sm={8} lg={9} className="degreeContent">
          <Row>
            <Col xs={12}>
              <span className="title">
                {isEditing ? (
                  <input
                    type="text"
                    className="form-control d-inline w-auto me-2"
                    value={pgData.degree || ''}
                    onChange={(e) => onFieldChange('degree', e.target.value)}
                    placeholder="Degree"
                  />
                ) : (
                  isSpecifyDegree(pgData?.degree)
                    ? (pgData?.otherDegree || pgData?.degree)
                    : pgData?.degree
                )}
              </span>
              <span className="sub-title">
                {isEditing ? (
                  <>
                    at <input
                      type="text"
                      className="form-control d-inline w-auto mx-2"
                      value={pgData.universityOrCollege || ''}
                      onChange={(e) => onFieldChange('universityOrCollege', e.target.value)}
                      placeholder="University/College"
                    />
                  </>
                ) : (
                  pgData.universityOrCollege && <> {' '}at {pgData.universityOrCollege}</>
                )}
              </span>
            </Col>
          </Row>

          {(isEditing || (pgData.universityCollegeDetails?.startYear || pgData.universityCollegeDetails?.endYear)) && (
            <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
              {isEditing ? (
                <>
                  <input
                    type="text"
                    className="form-control form-control-sm d-inline w-auto"
                    value={pgData.universityCollegeDetails?.startYear || ''}
                    onChange={(e) => onFieldChange('universityCollegeDetails.startYear', e.target.value)}
                    placeholder="Start Year"
                  />
                  <span>to</span>
                  <input
                    type="text"
                    className="form-control form-control-sm d-inline w-auto"
                    value={pgData.universityCollegeDetails?.endYear || ''}
                    onChange={(e) => onFieldChange('universityCollegeDetails.endYear', e.target.value)}
                    placeholder="End Year"
                  />
                  <input
                    type="text"
                    className="form-control form-control-sm d-inline w-auto"
                    value={pgData.typeOfCourse || ''}
                    onChange={(e) => onFieldChange('typeOfCourse', e.target.value)}
                    placeholder="Type of Course"
                  />
                </>
              ) : (
                <span className="sub-title1">
                  {pgData.universityCollegeDetails?.startYear} - {pgData.universityCollegeDetails?.endYear} - {pgData.typeOfCourse || ''}
                </span>
              )}
            </div>
          )}

        </Col>
        {(
          _.get(pgData, 'universityCollegeDetails.cgpa') ||
          (_.get(pgData, 'universityCollegeDetails.hasBackPapers') === 'YES' && _.get(pgData, 'universityCollegeDetails.backPapers.length') > 0)
        ) && (
            <Col xs={2} sm={2} lg={2} className="d-flex align-items-start justify-content-end viewDetailsContainer">
              <a
                className="viewDetailsToggle"
                onClick={(e) => {
                  e.preventDefault();
                  setViewDetails(!viewDetails);
                }}
              >
                <span className="viewMoreText-Ed">{viewDetails ? 'View Less' : 'View Details'}</span>
                <FontAwesomeIcon icon={viewDetails ? faChevronUp : faChevronDown} className="viewMoreIcon" />
              </a>
            </Col>
          )}
      </Row>

      {(viewDetails || isEditing) && (

        <Row className={`p-1 mt-1 expandedDetails pt-2 ${viewDetails && 'd-flex justify-content-center align-items-center'}`}>
          <Col lg={1}>&nbsp;</Col>
          <Col lg={9} md={8} xs={8}>
            <Row>
              <Col lg={12}>
                <p className='cgpa-container'>CGPA/Percentage:{' '}
                  {isEditing ? (
                    <input
                      type="text"
                      className="form-control d-inline w-auto"
                      value={_.get(pgData, 'universityCollegeDetails.cgpa') || ''}
                      onChange={(e) => onFieldChange('universityCollegeDetails.cgpa', e.target.value)}
                    />
                  ) : (
                    <span className="cgpa">{_.get(pgData, 'universityCollegeDetails.cgpa')}</span>
                  )}
                </p>
              </Col>
              {_.get(pgData, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
                Array.isArray(_.get(pgData, 'universityCollegeDetails.backPapers')) &&
                pgData.universityCollegeDetails.backPapers.length > 0 && (
                  <Col lg={12} className="mt-3">
                    <h5 className="jobDetailsTitle">Back Papers</h5>
                    <ul className="jobDetailsContent">
                      {pgData.universityCollegeDetails.backPapers.map((bp, idx) => (
                        <li key={`bp-${idx}`}>

                          {isEditing ? (
                            <>
                              <input
                                type="text"
                                className="form-control d-inline w-auto ms-2"
                                value={bp.startYear || ''}
                                onChange={(e) => {
                                  const updated = [...pgData.universityCollegeDetails.backPapers];
                                  updated[idx] = { ...updated[idx], startYear: e.target.value };
                                  onFieldChange('universityCollegeDetails.backPapers', updated);
                                }}
                              />
                              to
                              <input
                                type="text"
                                className="form-control d-inline w-auto ms-2"
                                value={bp.endYear || ''}
                                onChange={(e) => {
                                  const updated = [...pgData.universityCollegeDetails.backPapers];
                                  updated[idx] = { ...updated[idx], endYear: e.target.value };
                                  onFieldChange('universityCollegeDetails.backPapers', updated);
                                }}
                              />
                              <input
                                type="text"
                                className="form-control d-inline w-auto ms-2"
                                value={bp.reasons || ''}
                                onChange={(e) => {
                                  const updated = [...pgData.universityCollegeDetails.backPapers];
                                  updated[idx] = { ...updated[idx], reasons: e.target.value };
                                  onFieldChange('universityCollegeDetails.backPapers', updated);
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <ul>
                                {bp.startYear || bp.endYear ? (
                                  <>
                                    {bp.startYear}
                                    {bp.startYear && ' - '}
                                    {bp.endYear}
                                  </>
                                ) : null}</ul>
                              {' '}<ul>
                                Reason: {bp.reasons}</ul>
                            </>
                          )}
                        </li>
                      ))}

                    </ul>
                  </Col>
                )}
            </Row>
          </Col>
          <Col lg={2}>&nbsp;</Col>
        </Row>
      )}
    </Container>
  );
};

export default CandidateDegreeInfoPanel;